import type { SupportedLocale } from "@repo/core";
import { localizedDefaultCategories } from "../i18n/labels";
import type {
  Account,
  Category,
  Debt,
  NetWorthLog,
  SinkingFund,
  Transaction,
} from "./schema";

/**
 * Pure plan of what Clear All Data leaves in the DB (suite-safe — no IndexedDB).
 * Must stay in sync with clearAllData() in db.ts.
 */
export function planClearAllData(locale: SupportedLocale = "en"): {
  categories: Category[];
  accounts: Account[];
  transactions: Transaction[];
  debts: Debt[];
  sinkingFunds: SinkingFund[];
  netWorthLogs: NetWorthLog[];
} {
  return {
    categories: localizedDefaultCategories(locale),
    accounts: [],
    transactions: [],
    debts: [],
    sinkingFunds: [],
    netWorthLogs: [],
  };
}
